export default "__VITE_ASSET__CmwiITda__"